import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FileEditor, toPreview } from '#/shared/ui/file-editor'
import type { FilePreview } from '#/shared/ui/file-editor'

import type { PanelState } from './panel-state'
import { ShipmentFiles } from './shipment-files'

export function FileTab({
  file,
  compact,
  shipmentId,
}: {
  file: PanelState['file']
  compact?: boolean
  shipmentId?: string
}) {
  const { t } = useTranslation()
  const selection = file.selection
  const previews = useMemo<FilePreview[]>(
    () => (selection ? [toPreview(selection)] : []),
    [selection],
  )
  useEffect(() => {
    return () => {
      previews.forEach((p) => {
        if (p.url) URL.revokeObjectURL(p.url)
      })
    }
  }, [previews])
  return (
    <FileEditor
      compact={compact}
      multiple={false}
      files={previews}
      onAddFiles={file.onPick}
      onFilesChange={(next) => {
        if (next.length === 0) file.onClear()
      }}
      onCancel={file.onCancel}
      onSave={(_files, name) => file.onSave(name)}
      isSubmitting={file.isUploading}
      saveLabel={file.isUploading ? t('table.saving') : undefined}
      extraContent={compact ? <ShipmentFiles shipmentId={shipmentId} /> : null}
    />
  )
}
